module.exports = __webpack_public_path__ + "media/svg/cu-2bdff072.svg";